import { RECEIVED } from "./demo";
import { ReceivedChip } from "./EinvoiceStatus";
import "../clients/tables.css";
import "../clients/clientShow.css";

export function EinvoiceReceived() {
  return (
    <div className="fx-page" key="received">
      <aside className="fx-einv-note">
        <strong>L’expert-comptable ne remplace pas cette boîte</strong>
        <p>
          Lui tient les comptes. Ici, c’est la boîte du SIREN : les factures
          que tes fournisseurs t’envoient. Pour tes clients micro / TPE, on
          la posera <em>simple</em> (liste + PDF), pas une compta. Le cabinet
          continue avec son outil ; on pourra lui filer le ZIP. Si tout passe
          déjà chez lui, on laisse cet onglet éteint.
        </p>
      </aside>
      <div className="fx-clients-wrap">
        <table className="fx-clients-table">
          <thead>
            <tr>
              <th scope="col">N°</th>
              <th scope="col">Fournisseur</th>
              <th className="is-num" scope="col">Montant</th>
              <th scope="col">Reçue le</th>
              <th scope="col">Statut</th>
            </tr>
          </thead>
          <tbody>
            {RECEIVED.map((row) => (
              <tr key={row.id}>
                <td>
                  <span className="fx-clients-table__name">{row.number}</span>
                  <span className="fx-clients-table__meta">{row.motif}</span>
                </td>
                <td>{row.supplier}</td>
                <td className="is-num">{row.amount}</td>
                <td className="fx-clients-table__muted">{row.receivedAt}</td>
                <td>
                  <ReceivedChip status={row.status} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
